import React from 'react';
import isDisabled from '../../common/DisabledRoleCheck';

export default function (WrappedComp, roleButtons, roleCheckData) {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state={
                disabled:false
            }
            this.setStateByAccessRight = this.setStateByAccessRight.bind(this)
        }
        
        setStateByAccessRight(){
            if (!this.props.button_id){
                return
            }
            const disabled = isDisabled(this.props.button_id, roleButtons, roleCheckData)
            this.setState({
                disabled
            })
        }

        componentDidMount(){
            this.setStateByAccessRight()
        }
        
        componentDidUpdate(prevProps) {
            if(JSON.stringify(this.props) === JSON.stringify(prevProps))
                return;
                
            this.setStateByAccessRight()
        }
    
        render() {
            const disabled = this.props.disabled ? (
                this.props.disabled !== this.state.disabled? true: this.props.disabled
            ):this.state.disabled
            const view = this.props.disabled_view === undefined ? true : this.props.disabled_view == false && disabled == true ? false : true;
            if(view == true ) {
                return <WrappedComp {...this.props} disabled={disabled} />
            }else{
                return "";
            }
        }
    }
}